/**
 * 菜单删除
 */
import React from 'react';
import { Modal, message } from 'antd';
import PropTypes from 'prop-types';
import styles from './DeleteModal.module.scss';
import http from '@/assets/api/http';

class DeleteModal extends React.Component {

    state = {
        confirmLoading: false
    }

    _handleOk = () => {
        const { id } = this.props;

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.delMenuInfo', { id }, 'POST').then(() => {
            message.success('删除成功！');
            this.props.closeModal(true);
        }).catch((e) => {
            message.error(e.message);
        });
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading } = this.state;

        return (
            <Modal
                width={470}
                centered
                title='菜单删除'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    是否确定删除？
                </div>
            </Modal>
        );

    }
}

DeleteModal.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 菜单ID
    systemType: PropTypes.string, // 弹框入参
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default DeleteModal;